// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--bV4b2"};